import React, { useEffect } from 'react';
import { Navbar, Footer } from '../components';
import './ContactPage.css';

const ContactPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="contact-page">
            <Navbar />

            <div className="contact-wrapper">
                {/* HERO */}
                <section className="contact-hero">
                    <div className="contact-hero-text">
                        <h1>We're here<br />to <em>help you</em><br />remember.</h1>
                        <p>Whether you have a question, need guidance on getting started, or simply want to learn more about preserving a loved one's memory — our team is ready to listen.</p>
                    </div>
                    <div className="contact-hero-decoration">
                        <div className="circle-bg">
                            <div className="icon">🕊️</div>
                            <div className="tagline">"Every voice deserves<br />to be heard forever."</div>
                            <div className="sub">— The SayAgain Team</div>
                        </div>
                    </div>
                </section>

                {/* CONTACT SECTION */}
                <section className="contact-section">
                    {/* Left: Info */}
                    <div className="info-panel">
                        <h2>Get in Touch</h2>
                        <p>We treat every message with the care it deserves. Reach out through any channel below, and a real person from our team will respond.</p>

                        <div className="contact-item">
                            <div className="contact-icon">✉️</div>
                            <div className="contact-item-text">
                                <h4>Email Us</h4>
                                <p><a href="mailto:hello@sayagain.ai">hello@sayagain.ai</a></p>
                                <p>For general questions & support</p>
                            </div>
                        </div>

                        <div className="contact-item">
                            <div className="contact-icon">💬</div>
                            <div className="contact-item-text">
                                <h4>Live Chat</h4>
                                <p>Available Mon – Fri, 9 AM – 6 PM EST</p>
                                <p>Click the chat icon at the bottom right</p>
                            </div>
                        </div>

                        <div className="contact-item">
                            <div className="contact-icon">🤝</div>
                            <div className="contact-item-text">
                                <h4>Partnerships & Press</h4>
                                <p><a href="mailto:hello@sayagain.ai">hello@sayagain.ai</a></p>
                                <p>Media inquiries & collaborations</p>
                            </div>
                        </div>

                        <div className="response-note">
                            <strong>💛 Our promise to you:</strong><br />
                            We respond to every message within <strong>24 hours</strong>. If your matter is urgent or you are going through a difficult time, please say so in your message and we will prioritize your response.
                        </div>
                    </div>

                    {/* Right: Form */}
                    <div className="form-panel">
                        <h3>Send us a message</h3>
                        <p>Fill out the form and we'll get back to you as soon as possible.</p>

                        <div className="form-row">
                            <div className="field">
                                <label>First Name</label>
                                <input type="text" placeholder="Jane" />
                            </div>
                            <div className="field">
                                <label>Last Name</label>
                                <input type="text" placeholder="Smith" />
                            </div>
                        </div>

                        <div className="field">
                            <label>Email Address</label>
                            <input type="email" placeholder="jane@example.com" />
                        </div>

                        <div className="field">
                            <label>How Can We Help?</label>
                            <select defaultValue="">
                                <option value="" disabled>Select a topic…</option>
                                <option>Getting Started with SayAgain</option>
                                <option>Technical Support</option>
                                <option>Billing & Subscription</option>
                                <option>Privacy & Data Questions</option>
                                <option>Grief Support Resources</option>
                                <option>Partnership or Press Inquiry</option>
                                <option>Other</option>
                            </select>
                        </div>

                        <div className="field">
                            <label>Your Message</label>
                            <textarea placeholder="Tell us what's on your mind. There are no wrong words here."></textarea>
                        </div>

                        <button className="btn-submit">Send Message →</button>

                        <div className="form-footer">
                            🔒 Your information is private and will never be shared.<br />
                            We treat every message with the same care we bring to preserving memories.
                        </div>
                    </div>
                </section>

                {/* FAQ STRIP */}
                <section className="faq-section">
                    <div className="faq-inner">
                        <h2>Common Questions</h2>
                        <p>Answers to things we hear most often.</p>
                        <div className="faq-grid">
                            <div className="faq-card">
                                <h4>How does SayAgain work?</h4>
                                <p>SayAgain uses advanced AI to help you preserve the voice, stories, and personality of someone you love — creating an interactive memory you can return to anytime.</p>
                            </div>
                            <div className="faq-card">
                                <h4>Is my data safe and private?</h4>
                                <p>Absolutely. All memories and personal data are encrypted and stored securely. We will never sell, share, or use your information for any purpose beyond the service.</p>
                            </div>
                            <div className="faq-card">
                                <h4>What if I need emotional support?</h4>
                                <p>We understand grief is deeply personal. Our team is trained to respond with compassion, and we can connect you with professional support resources if needed.</p>
                            </div>
                            <div className="faq-card">
                                <h4>Can I create a memory for someone still living?</h4>
                                <p>Yes — in fact, we encourage it. Capturing someone's essence while they're present creates a richer, more meaningful memory for generations to come.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    );
};

export default ContactPage;
